var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrangeColorIndicatorIcon = function SvgOrangeColorIndicatorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4,
    r: 4,
    fill: "#FD7F38"
  })));
};
export { SvgOrangeColorIndicatorIcon as ReactComponent };
export default __webpack_public_path__ + "4c2c72e837de0b35f8b0102cbd4e4d71.svg";